import { getAppParams } from './app-params';
import { getURL, isSEO, isSSR } from './wix-code-api';
export const getArtifactVersion = () => {
    if (process.env.NODE_ENV === 'production') {
        return process.env.ARTIFACT_VERSION;
    }
    return 'local-development';
};
export const createErrorMonitor = ({ essentials, wixCodeApi, appParams, }) => {
    const { appName, appDefinitionId, appVersion } = getAppParams(appParams);
    // HACK: essentials.createErrorMonitor is missing in Yoshi testkit and dev server.
    if (process.env.NODE_ENV === 'test' ||
        process.env.NODE_ENV === 'development') {
        const errorMonitor = {
            addBreadcrumb: () => { },
            captureException: () => 'captureException',
            captureMessage: () => 'captureMessage',
        };
        return errorMonitor;
    }
    const errorMonitor = essentials.createErrorMonitor({
        dsn: 'https://02ede3d0e8514c8eb7de072a1633a404@sentry-next.wixpress.com/15216',
        environment: 'Controller',
        version: getArtifactVersion(),
        tags: {
            appName,
            appDefinitionId,
            appVersion,
            isSSR: isSSR(wixCodeApi),
            isSEO: isSEO(wixCodeApi),
            url: getURL(wixCodeApi),
        },
    });
    return errorMonitor;
};
//# sourceMappingURL=error-monitor.js.map